<template>
    <section class="CTable">
        <template v-if="!noTitle">
            <c-search :title="title" :queryArr="queryArr" :seniorArr="seniorArr" @sendQueryData="sendQueryData" v-if="queryArr.length">
                <slot name="buttons"></slot>
            </c-search>
            <c-query :title="title" :queryList="queryList" v-else-if="queryList.length" @sendQueryData="sendQueryData">
                <slot name="buttons"></slot>
            </c-query>
            <c-head :title="title" v-else>
                <slot name="buttons"></slot>
            </c-head>
        </template>
        <el-table
            v-bind="$attrs" v-on="$listeners" ref="elTable"
            :data="tableList" v-loading="loading" :stripe="stripe"
            @sort-change="sortChange">
            <slot></slot>
        </el-table>
        <el-pagination class="fr" :total="total" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizes"
            @current-change="getList" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </section>
</template>

<script>

import CSearch from '@/components/CSearch'
import CHead from '@/components/CHead'
import { generateUUID } from '@/utils'
export default {
    name: 'CTable',
    inheritAttrs: false,
    props: {
        /* 请求的接口地址
         * String类型的即直接传接口地址即可
         * Object类型 {
         *   path:String  接口地址
         *   data:{}  请求体
         * }
         */
        api: {
            type: [String, Object]
        },
        // 标题
        title: {
            type: String
        },
        // 格式化列表数据
        formatData: {
            type: Function
        },
        // 查询数组
        queryArr: {
            type: Array,
            default: () => []
        },
        queryList: {
            type: Array,
            default: () => []
        },
        // 高级查询数组
        seniorArr: {
            type: Array,
            default: () => []
        },
        // 不可更改的查询条件
        queryObj: {
            type: Object,
            default: () => ({})
        },
        // 复写斑马线，默认为开启
        stripe: {
            type: Boolean,
            default: true
        },
        // 当前是否为测试模式
        test: {
            type: Boolean,
            default: false
        },
        // 是否禁用标题
        noTitle: {
            type: Boolean,
            default: false
        },
        mySort: {
            type: String
        },
        visible: {
            type: Boolean,
            default: true
        },
        defaultPageSize: {
            type: Number,
            default: 10
        },
        pageSizes: {
            type: Array,
            default: () => [10, 20, 30, 40, 50, 100]
        }
    },
    data() {
        return {
            conditions: {}, // 查询条件
            total: 0, // 总条数
            totalPages: 0, // 总页数
            currentPage: 1, // 当前页码
            pageSize: this.defaultPageSize, // 每页显示多少条
            tableList: [], // 列表数据
            loading: false, // 加载中
            sortStr: this.mySort // 排序信息
        }
    },
    watch: {
        api() {
            this.currentPage = 1
            this.getList('api')
        },
        totalPages(page) {
            // 修复最后一页只有一条的情况下删除该条导致不请求上一页数据的bug
            if (this.currentPage === page + 1) {
                this.currentPage--
                this.getList('totalPages')
            }
        }
    },
    methods: {
        sortChange({ column, prop, order }) {
            if (order === null) {
                this.sortStr = this.mySort
            } else {
                this.sortStr = `${prop},${order === 'ascending' ? 'asc' : 'desc'}`
            }
            this.getList('sortChange')
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize
            this.currentPage = 1
            this.getList('sizeChange')
        },
        getList(type) {
            if (!this.visible) {
                this.tableList = []
                return
            }
            if (!this.test) {
                let type = Object.prototype.toString.call(this.api).slice(8, -1)
                const path = type === 'Object' ? this.api.path : this.api
                const data = type === 'Object' ? Object.assign(this.conditions, this.queryObj, this.api.data) : Object.assign(this.conditions, this.queryObj)
                this.$http('POST', path, {
                    data: data,
                    params: {
                        page: this.currentPage - 1,
                        size: this.pageSize,
                        sort: this.sortStr
                    },
                    self: this,
                    loading: 'loading'
                }).then(res => {
                    if (res.data.code === 200) {
                        if (typeof this.formatData === 'function') {
                            this.tableList = this.formatData(res.data.content.content)
                        } else {
                            this.tableList = res.data.content.content
                        }
                        this.total = res.data.content.totalElements
                        this.totalPages = res.data.content.totalPages
                    }
                })
            } else {
                this.tableList = [{
                    id: generateUUID()
                }, {
                    id: generateUUID()
                }, {
                    id: generateUUID()
                }]
            }
        },
        sendQueryData(obj) {
            this.conditions = obj
            this.getList('sendQueryData')
        },
        // 刷新列表
        refresh() {
            this.getList('refresh')
        }
    },
    created() {
        !this.getted && this.getList('created')
        this.getted = true
    },
    activated() {
        !this.getted && this.getList('activated')
        this.getted = true
    },
    deactivated() {
        this.getted = false
    },
    components: {
        CSearch,
        CHead
    }
}
</script>

<style lang="scss" scoped>
.CTable {
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/global/CTable.vue